import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';
import ProgramContent from '../../components/Pages/Program';

const { displayName } = config;

export default function Program(): React.ReactNode | null {
  document.title = `${displayName}: Программа`;

  return (
    <Layout>
      <ProgramContent />
    </Layout>
  );
}
